import { Skeleton } from "@/components/ui/skeleton";
import { ReactNode } from "react";
import FilterChip from "../property/FilterChip";

interface FilterChipSectionProps {
  title: string;
  options: string[];
  selectedOptions: string[];
  icon: ReactNode;
  onOptionClick: (option: string) => void;
  variant?: "default" | "outline" | "ghost";
  size?: "sm" | "md" | "lg";
  isLoading?: boolean;
}

const FilterChipSection = ({
  title,
  options,
  selectedOptions,
  icon,
  onOptionClick,
  variant = "default",
  size = "md",
  isLoading = false,
}: FilterChipSectionProps) => {
  return (
    <div className="p-4 bg-gray-50 border-t border-gray-200 animate-accordion-down">
      <div className="flex items-center justify-between mb-2">
        <h4 className="text-xs font-medium text-gray-500">{title}</h4>
      </div>
      <div className="flex flex-wrap gap-2">
        {isLoading ? (
          <>
            <Skeleton className="h-8 w-20 rounded-full" />
            <Skeleton className="h-8 w-24 rounded-full" />
            <Skeleton className="h-8 w-16 rounded-full" />
            <Skeleton className="h-8 w-20 rounded-full" />
          </>
        ) : (
          options.map((option) => (
            <FilterChip
              key={option}
              label={option}
              isSelected={selectedOptions.includes(option)}
              onClick={() => onOptionClick(option)}
              icon={icon}
              variant={variant}
              size={size}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default FilterChipSection;
